<section class="seo-service">
    <div class="container-fluid">
        <div class="row center-align">
            <div class="col-md-6 text-center">
                <img src="./../../../assets/images/desktop-image-2.png" alt="seo" />
            </div>            
            <div class="col-md-6">
                <div class="service">
                    <h2>
                        ما هى تطبيقات سطح المكتب(Desktop Applications)
                    </h2>
                    <p>
                        تطبيقات سطح المكتب يعني البرامج التي يمكن تثبيتها على جهاز كمبيوتر واحد (الكمبيوتر المحمول أو المكتبي) وتستخدم لأداء مهام محددة. ويمكن أيضا أن بعض تطبيقات سطح المكتب يتم استخدامها من قبل العديد من المستخدمين في بيئة شبكية (network)
                    </p>
                </div>
                <div class="service">
                    <h2>
                        مميزات Desktop application :
                    </h2>
                    <ul class="fa-ul text-right">
                        <li>                      
                            من الصعب اختراق البرمج (لقلة المستخدمين) .
                          <span class="fa-li"><i class="fas fa-check"></i></span>
                        </li>
                        <li>                      
                            حماية تكاد تصل الى نسبة 90% .
                          <span class="fa-li"><i class="fas fa-check"></i></span>
                        </li>
                        <li>                      
                            الحفاظ على البيانات .
                          <span class="fa-li"><i class="fas fa-check"></i></span>
                        </li>
                        <li>                      
                            سهولة الوصول للداتا بيز (دائما منسوخة بالقرص المثبت علية البرنامج) .
                          <span class="fa-li"><i class="fas fa-check"></i></span>
                        </li> 
                        <li>                      
                            سهولة التعامل مع الداتا بيز (لقلة المستخدمين) .
                          <span class="fa-li"><i class="fas fa-check"></i></span>
                        </li>
                        <li>                      
                            كثرة مبرمجين الديسك توب .
                          <span class="fa-li"><i class="fas fa-check"></i></span>
                        </li> 
                        <li>                      
                            قلة مستخدمين البرنامج .
                          <span class="fa-li"><i class="fas fa-check"></i></span>
                        </li>                                                                                                                      
                    </ul>
                </div>                
            </div>
        </div>
    </div>
</section>